export const environment = {
  production: true,
  stripeKey: "pk_live_C2JYxb7GOw2UgGHG3wUiWpzB00NjQBjFoM",
  gtag: "UA-151181389-2",
  stackDriverAPIKey: "AIzaSyAPAhhrDh0Oi109J9noV1Bmj3ehU_FyKys",
  stackDriverProjectID: "csper-258318",
};
